import React from "react";

import {useParams} from "react-router";
import {useRequest} from "ahooks";
import * as api from "../../apis/common";
import {Card, Col, Empty, Row, Skeleton, Image} from "antd";


function ProductPicture() {

    const {model} = useParams<{ model: string }>()

    const {data = [], loading} = useRequest(async () => api.getProductPicture(model), {
        refreshDeps: [model]
    })

    return (
        <div style={{padding: 15}}>
            {loading ? (
                <Skeleton active/>
            ) : (data.length === 0 ? (
                    <Empty/>
                ) : (
                    <div>
                        <Row gutter={[15, 15]}>
                            {data.map((product: any) => (
                                <Col lg={6} md={12} sm={24}>
                                    <Card hoverable
                                          cover={(
                                              <Image
                                                  width={'100%'}
                                                  style={{
                                                      aspectRatio: '1/1',
                                                      objectFit: 'contain'
                                                  }}
                                                  src={product.url}/>
                                          )}
                                    >
                                        <Card.Meta description={product.name}/>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </div>
                )
            )}
        </div>
    )
}

export default ProductPicture;
